import { RefAttributes } from "react";
import { Link as RouterLink } from "react-router-dom";
import { GridActionsCellItemProps } from "@mui/x-data-grid-pro";
import ActionButton from "./ActionButton";

type GridLinkActionProps = {
  to: string | { pathname: string; state?: unknown };
  bgColor: string;
  bgColorHover: string;
  label: string;
  color?: string;
  icon: React.JSX.Element;
  dataTestId?: string;
} & GridActionsCellItemProps &
  RefAttributes<HTMLButtonElement>;

const GridLinkAction = ({
  to,
  bgColor,
  bgColorHover,
  dataTestId,
  ...props
}: GridLinkActionProps) => (
  <RouterLink to={to}>
    <ActionButton
      label={props.label}
      bgColor={bgColor}
      bgColorHover={bgColorHover}
      color={props.color || "white"}
      dataTestId={dataTestId}
    >
      {props.icon}
    </ActionButton>
  </RouterLink>
);

export default GridLinkAction;
